var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v("Shipping Status")]),_c('v-card-subtitle',[_vm._v("Shipment #"+_vm._s(_vm.value.id))]),_c('v-container',[_c('StepIndicator',{attrs:{"steps":_vm.shipment_statuses,"currentStatusId":_vm.getCurrentStatus(_vm.value.common_status)},on:{"close-dialog":() => _vm.close()}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }